export default "/images/833f0cbdecf4c2d3ba577388eeeefcd1.avif";